"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFutureDate = void 0;
var generateFutureDate = function () {
    var now = new Date();
    var minutes = Math.floor(Math.random() * 61) + 30;
    var seconds = Math.floor(Math.random() * 60);
    now.setMinutes(now.getMinutes() + minutes);
    now.setSeconds(now.getSeconds() + seconds);
    return now;
};
exports.generateFutureDate = generateFutureDate;
